import { z } from 'zod';

/**
 * Realtime carries hints, never state (plan §27): the client refetches over HTTP,
 * so duplicates, reordering and gaps are harmless.
 */
export const REALTIME_EVENT_TYPES = [
  'message.created',
  'conversation.updated',
  'room.updated',
  'room.turn_resolved',
  'story.updated',
  'relationship.changed',
  'manga.progress',
  'manga.ready',
  'job.failed',
  'wallet.updated',
  'friend.updated',
  'notification.created',
] as const;
export const RealtimeEventType = z.enum(REALTIME_EVENT_TYPES);
export type RealtimeEventType = z.infer<typeof RealtimeEventType>;

export const RealtimeEvent = z.object({
  eventId: z.string(),
  type: RealtimeEventType,
  entityId: z.string(),
  revision: z.number().int().nullable(),
  occurredAt: z.string(),
});
export type RealtimeEvent = z.infer<typeof RealtimeEvent>;

export const REALTIME_SOCKET_EVENT = 'hint';
export const REALTIME_SUBSCRIBE = 'subscribe';
export const realtimeChannel = {
  user: (id: string) => `user:${id}`,
  conversation: (id: string) => `conversation:${id}`,
  room: (id: string) => `room:${id}`,
} as const;
